<template>
  <div class="o-carousel" id="o-carousel" v-resize="onResize">
    <div class="o-carousel-wrapper" :style="'width:' + getWidth() + 'px;' + 'height:' + wrapperHeight + 'px;'"
         v-on:mousedown="mouseDown" v-on:touchstart="mouseDown"
         v-on:mouseup="mouseUp" v-on:touchend="mouseUp"
         v-on:touchmove="mouseMove" v-on:mousemove="mouseMove">
      <!-- items-->
      <div class="o-carousel-item" :id="'o-carousel-item-' + i" v-for="(item, i) in items" :key="i" :style="'width:' + getWidth() + 'px;' + ((item.type === 'video')? ('height:' + getYoutubeHeight() + 'px;') : '') " >
        <div v-if="item.type == 'video'" style="width: 100%;">
          <youtube :video-id="item.src" :ref="'youtubeplayer-' + i" :width="getWidth() + 'px'" :height="getYoutubeHeight() + 'px'" @ready="youtubeStatus('youtubeplayer-' + i, 'ready')" @playing="youtubeStatus('youtubeplayer-' + i, 'playing')" @ended="youtubeStatus('youtubeplayer-' + i, 'ended')" @buffering="youtubeStatus('youtubeplayer-' + i, 'buffering')" @cued="youtubeStatus('youtubeplayer-' + i, 'cued')"></youtube>
        </div>
        <div v-else style="width: 100%;">
          <img :src="item.src" v-on:load="imgLoad()"/>
        </div>
        <div class="o-carousel-item-tag" v-if="item.type && item.type != 'video'">
          #{{(item.type === 'item') ? '내부' : item.type}}
        </div>
      </div>
    </div>
    <!-- button-->
    <div class="o-carousel-numbertext">{{printNumberText()}}</div>
    <!-- button-->
    <a class="o-carousel-prev" id="o-carousel-prev" @click="prevItem()">
      <v-icon size="46">chevron_left</v-icon>
    </a>
    <a class="o-carousel-next" id="o-carousel-next" @click="nextItem()">
      <v-icon size="46">chevron_right</v-icon>
    </a>
  </div>
</template>

<script>
// import loadScriptOnce from 'load-script-once'
export default {
  name: 'OCarousel',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    state: {
      isReady: false
    },
    pos: {
      fX: 0,
      mX: 0,
      isDrag: false
    },
    carousel: null,
    slideIndex: 0,
    slidePrevIndex: 0,
    slideItems: [],
    isMoving: false,
    wrapperHeight: 0,
    transition: 'left 0.3s',
    autoDelay: 4000,
    timer: null,
    resizeTimer: 0,
    playingVideo: null,
    videoItemCount: 0
  }),
  mounted () {
    this.state.isReady = true
    // console.log('mounted!!!')
    this.$nextTick(() => {
      //
    })
    this.reset(this.items)
  },
  beforeDestroy () {
    // console.log('beforeDestroy!!!')
    this.clearTimer()
  },
  watch: {
    items (val) {
      if (this.items) {
        // console.log('Watch Items / ' + this.items.length)
        this.reset(this.items)
      }
    }
  },
  methods: {
    clearTimer () {
      if (this.timer != null) {
        clearInterval(this.timer)
        this.timer = null
        // console.log('clearTimer!')
      }
    },
    startTimer () {
      if (this.timer === null && this.slideItems.length > 1) {
        this.timer = setInterval(function () {
          // next
          this.slide(1)
        }.bind(this), this.autoDelay)
      }
    },
    onResize () {
      if (this.state.isReady) {
        if (this.resizeTimer === null) {
          this.resizeTimer = setTimeout(function () {
            this.resizeTimer = null
            this.reset(this.items)
          }.bind(this), 200)
        }
      }
    },
    printNumberText () {
      return (this.slideIndex + 1) + ' / ' + this.items.length
    },
    getWidth () {
      if (document.getElementById('o-carousel') === null) {
        return 0
      }
      return document.getElementById('o-carousel').clientWidth
    },
    getYoutubeHeight () {
      return (this.getWidth() / 16) * 9
    },
    youtubeStatus (refId, type) {
      console.log(`youtubeStatus : ${refId} / ${type}`)
      if (type === 'playing' || type === 'buffering') {
        this.playingVideo = refId
        // 회전멈춤
        this.clearTimer()
      } else if (type === 'ready') {
        // 리소스 로드 높이 보정
        if (this.slideItems.length > 0) {
          this.wrapperHeight = this.slideItems[this.slideIndex]['elem'].clientHeight
        }
        // 타이머
        this.videoItemCount--
        if (this.videoItemCount === 0) {
          this.startTimer()
        }
      }
    },
    imgLoad () {
      // 리소스 로드 높이 보정
      if (this.slideItems.length > 0) {
        this.wrapperHeight = this.slideItems[this.slideIndex]['elem'].clientHeight - 1
      }
    },
    mouseDown (e) {
      e = e || window.event
      e.preventDefault()
      if (e.type === 'touchstart') {
        this.pos.fX = e.touches[0].clientX
      } else {
        this.pos.fX = e.clientX
      }
      this.slideItems[this.slideIndex]['elem'].style.transition = 'none'
      this.pos.isDrag = true
      // 타이머 캔슬
      this.clearTimer()
    },
    mouseMove (e) {
      if (this.pos.isDrag) {
        e = e || window.event
        if (e.type === 'touchmove') {
          this.pos.mX = e.touches[0].clientX - this.pos.fX
        } else {
          this.pos.mX = e.clientX - this.pos.fX
        }
        // 이미지 드래그 처리
        this.slideItems[this.slideIndex]['elem'].style.transition = 'none'
        this.slideItems[this.slideIndex]['elem'].style.zIndex = 4
        if (this.pos.mX < 0) {
          let slideIndex = this.slideIndex
          slideIndex--
          if (slideIndex < 0) {
            slideIndex = this.slideItems.length - 1
          }
          this.slideItems[slideIndex]['elem'].style.transition = 'none'
          this.slideItems[slideIndex]['elem'].style.left = '0px'
          this.slideItems[slideIndex]['elem'].style.zIndex = 3
        } else if (this.pos.mX > 0) {
          let slideIndex = this.slideIndex
          slideIndex++
          if (slideIndex > (this.slideItems.length - 1)) {
            slideIndex = 0
          }
          this.slideItems[slideIndex]['elem'].style.transition = 'none'
          this.slideItems[slideIndex]['elem'].style.left = '0px'
          this.slideItems[slideIndex]['elem'].style.zIndex = 3
        }
        this.slideItems[this.slideIndex]['elem'].style.left = this.pos.mX + 'px'
      }
    },
    mouseUp (e) {
      if (this.pos.isDrag) {
        this.pos.isDrag = false
        this.slideItems[this.slideIndex]['elem'].style.transition = this.transition
        if (this.pos.mX < ((this.getWidth() / 3) * -1)) {
          this.prevItem()
        } else if (this.pos.mX > (this.getWidth() / 3)) {
          this.nextItem()
        } else {
          this.slideItems[this.slideIndex]['elem'].style.left = '0px'
        }
        this.pos.mX = 0
        //
        // console.log('mouseUp!')
      }
    },
    nextItem () {
      this.clearTimer()
      this.slide(1)
    },
    prevItem () {
      this.clearTimer()
      this.slide(-1)
    },
    slide (n) {
      if (this.slideItems.length > 1) {
        // console.log('slide!!!')
        if (!this.isMoving) {
          this.isMoving = true
          setTimeout(function () {
            // 좌표정리
            this.slideItems[this.slidePrevIndex]['elem'].style.transition = 'none'
            this.slideItems[this.slidePrevIndex]['elem'].style.zIndex = 0
            this.slideItems[this.slidePrevIndex]['elem'].style.left = '0px'
            // z-index 정리
            this.slideItems[this.slideIndex]['elem'].style.zIndex = 3
            // wrapper 높이 설정
            this.wrapperHeight = this.slideItems[this.slideIndex]['elem'].clientHeight - 1
            // 버튼 해제
            this.isMoving = false
          }.bind(this), 700)
          // 기존 아이템이 동영상이고 플레이 중이라면
          if (this.slideItems[this.slideIndex]['type'] === 'video') {
            if (this.playingVideo != null && this.playingVideo === this.slideItems[this.slideIndex]['refId']) {
              this.$refs[this.slideItems[this.slideIndex]['refId']][0].player.pauseVideo()
              this.playingVideo = null
            }
          }
          // 액션
          this.slidePrevIndex = this.slideIndex
          if (n === -1) {
            // console.log('slide: -1')
            this.slideItems[this.slideIndex]['elem'].style.transition = this.transition
            this.slideItems[this.slideIndex]['elem'].style.zIndex = 4
            this.slideItems[this.slideIndex]['elem'].style.left = '-' + this.getWidth() + 'px'
            this.slideIndex--
            if (this.slideIndex < 0) {
              this.slideIndex = this.slideItems.length - 1
            }
            this.slideItems[this.slideIndex]['elem'].style.zIndex = 3
          } else if (n === 1) {
            // console.log('slide: +1')
            this.slideItems[this.slideIndex]['elem'].style.transition = this.transition
            this.slideItems[this.slideIndex]['elem'].style.zIndex = 4
            this.slideItems[this.slideIndex]['elem'].style.left = this.getWidth() + 'px'
            this.slideIndex++
            if (this.slideIndex > (this.slideItems.length - 1)) {
              this.slideIndex = 0
            }
            this.slideItems[this.slideIndex]['elem'].style.zIndex = 3
            // wrapper 높이 설정
            this.wrapperHeight = this.slideItems[this.slideIndex]['elem'].clientHeight - 1
          }
        } else {
          this.slideItems[this.slideIndex]['elem'].style.left = '0px'
        }
      }
    },
    reset (items) {
      // console.log('reset!!!')
      // set items
      this.clearTimer()
      this.isMoving = false
      this.wrapperHeight = 0
      this.videoItemCount = 0
      this.slideIndex = 0
      this.slideItems = []
      for (let i = 0; i < items.length; i++) {
        this.slideItems.push({
          elem: document.getElementById('o-carousel-item-' + i),
          order: i,
          type: items[i]['type'],
          refId: ((items[i]['type'] === 'video') ? ('youtubeplayer-' + i) : '')
        })
        if (items[i]['type'] === 'video') {
          this.videoItemCount++
        }
      }
      // z-index
      for (let i = this.slideItems.length - 1; i >= 0; i--) {
        this.slideItems[i]['elem'].style.zIndex = 0
      }
      this.slideItems[this.slideIndex]['elem'].style.zIndex = 3
      // wrapper 높이 설정
      if (this.slideItems[this.slideIndex]['type'] === 'video') {
        this.wrapperHeight = this.getYoutubeHeight()
      } else {
        this.wrapperHeight = this.slideItems[this.slideIndex]['elem'].clientHeight - 1
      }
      // auto slide
      if (this.videoItemCount === 0) { // 유투브가 있다면 유투브 로딩 후
        this.startTimer()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  $v-breakpoint-xs: 600px;
  .o-carousel {
    max-width: 1000px;
    position: relative;
    margin: auto;
    .o-carousel-wrapper {
      width: 100%;
      overflow: hidden;
      position: relative;
      margin:auto;
      background: #000;
      z-index: 1;
      transition: height 0.2s;
      .o-carousel-item {
        background-color: #000;
        line-height: 1;
        width: 100%;
        margin:auto;
        cursor: pointer;
        display: flex;
        position: absolute;
        left:0;
        top:0;
        transition: left 0.3s;
        img {
          width: 100%;
          height: auto;
        }
      }
      .o-carousel-item-tag {
        background-color: rgba(46, 46, 46, 0.6);
        /* border: 1px solid rgba(255, 255, 255, 0.5); */
        border-radius: 15px;
        color: #f2f2f2;
        font-weight: 500;
        font-size: 15px;
        margin-bottom: 20px;
        margin-right: 25px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 2;
        padding: 4px 10px;
      }
    }
    /* next, prev */
    .o-carousel-prev i, .o-carousel-next i {
      color: white;
      font-weight: 500;
      font-size: 46px;
    }
    .o-carousel-prev, .o-carousel-next {
      cursor: pointer;
      position: absolute;
      top: 50%;
      width: auto;
      margin-top: -40px;
      padding: 10px 5px;
      transition: 0.5s ease;
      border-radius: 0 3px 3px 0;
      user-select: none;
      z-index: 2;
    }
    .o-carousel-next {
      right: 0;
      border-radius: 3px 0 0 3px;
    }
    .o-carousel-prev:active, .o-carousel-next:active {
      background-color: rgba(255,255,255,0.25);
      transition: 0.5s ease;
    }
    /* Number text (1/3 etc) */
    .o-carousel-numbertext {
      background-color: rgba(46, 46, 46, 0.6);
      border-radius: 15px;
      color: #f2f2f2;
      font-weight: 500;
      font-size: 12px;
      margin-top: 15px;
      margin-left: 18px;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      padding: 2px 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/plugin/carousel/OCarousel.vue